import React from "react";
import "../Company/About.css";
import { useTranslation } from "react-i18next";
import "./Ceo.css";

const Ceo = () => {
  const { t, i18n } = useTranslation();

  // 현재 언어 가져오기
  const currentLanguage = i18n.language;
  return (
    <div className="sub-wrap">
      <div className="inner_page_title">CEO profile</div>
      <div className="content">
        <div className="container">
          <div className="parents">
            <div class="image-container">
              <div class="image"></div>
            </div>
            <div class="text-container">
              <h2>{t("ceo.ceo01")}</h2>
              <p style={currentLanguage === "en" ? { fontSize: 17 } : {}}>
                · &nbsp;{t("ceo.ceo02")}
              </p>
              <p style={currentLanguage === "en" ? { fontSize: 16 } : {}}>
                · &nbsp;{t("ceo.ceo03")}
              </p>
              <p style={currentLanguage === "en" ? { fontSize: 17 } : {}}>
                · &nbsp;{t("ceo.ceo04")}
              </p>
              <p style={currentLanguage === "en" ? { fontSize: 17 } : {}}>
                · &nbsp;{t("ceo.ceo05")}
              </p>
              <p style={currentLanguage === "en" ? { fontSize: 16 } : {}}>
                · &nbsp;{t("ceo.ceo06")}
              </p>
              <p style={currentLanguage === "en" ? { fontSize: 17 } : {}}>
                · &nbsp;
                <a
                  href="https://scholar.google.co.kr/citations?hl=ko&user=LvyKVcAAAAAJ"
                  target="_blank"
                >
                  https://scholar.google.co.kr/citations?hl=ko&user=LvyKVcAAAAAJ
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ceo;
